<ras-page [show_heading]="true" *ngIf="location" [headingHtml]="'<b>' + location.name + '</b>'" [mapUrl]="location.map_url" [description]="location.description">

	<main>
		<h1>Rest easy, your unit is reserved</h1>

		<p><b>To complete your rental and move-in, you need to:</b></p>
		<ol>
			<li>Fill in and sign your lease</li>
			<li>Book your transport</li>
			<li>Pay your rent</li>
			<li>Submit your documents</li>
		</ol>

		<aside class="warning">
			<b>Note</b>: Free move-in transport gets booked fast towards the end of the month, so complete your rental as soon as possible to secure transport on your preferred day.
		</aside>

		<p>
			<a class="button" href="{{environment.webBaseUrl}}/booking.aspx?link=reservation_book&uid={{token}}" target="_blank">Complete rental online now</a>
		</p>

		<p>The fastest, easiest way to rent self-storage. Complete your rental online and move in 7 days a week during gate hours, between 6am and 6pm.</p>

		<hr>

		<p>If you choose not to complete your rental online, rest assured that one of our friendly consultants will contact you, during office hours, to assist you in completing your rental process.</p>

		<p>You are also more than welcome to visit us during office hours at the {{location.name}} facility, where we will be more than happy to assist you in person.</p>

		<aside class="info">If you require any further assistance, please call us during office hours on <a href="tel:0861736827">0861 73 68 27</a></aside>
	</main>

	<ras-testimonial></ras-testimonial>

</ras-page>

<!-- <ras-popup *ngIf="show_coupon_popup" (close)="show_coupon_popup = false">
	<img [src]="'/assets/box.svg'" alt="">
	<p>A coupon for <b>10 free boxes worth R230</b> has been sent to {{email}} !</p>
</ras-popup> -->
